import { IComponentUpdatePlugin } from './types';

export abstract class BaseComponentUpdatePlugin implements IComponentUpdatePlugin {
  id: string;
  name: string;
  enabled: boolean = true;

  constructor(id: string, name: string) {
    this.id = id;
    this.name = name;
  }

  disable(): void {
    this.enabled = false;
  }
}
